/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { mgmtJobOrderControllerRefreshParcelTracking } from '../fn/job/mgmt-job-order-controller-refresh-parcel-tracking';
import { MgmtJobOrderControllerRefreshParcelTracking$Params } from '../fn/job/mgmt-job-order-controller-refresh-parcel-tracking';

@Injectable({ providedIn: 'root' })
export class JobApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mgmtJobOrderControllerRefreshParcelTracking()` */
  static readonly MgmtJobOrderControllerRefreshParcelTrackingPath = '/api/job/orders/parcel-tracking';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mgmtJobOrderControllerRefreshParcelTracking()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtJobOrderControllerRefreshParcelTracking$Response(params?: MgmtJobOrderControllerRefreshParcelTracking$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = mgmtJobOrderControllerRefreshParcelTracking(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mgmtJobOrderControllerRefreshParcelTracking$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mgmtJobOrderControllerRefreshParcelTracking(params?: MgmtJobOrderControllerRefreshParcelTracking$Params, context?: HttpContext): Observable<void> {
    const resp = this.mgmtJobOrderControllerRefreshParcelTracking$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
